module.exports = __webpack_public_path__ + "media/images/show-4b4cf493f88fb594bc1a7072e5b52902.svg";